/**
 * Header logo click feedback (light sweep + spring press — see
 * logo-animation.css). Delegated on document so it works for whichever
 * logo_position variant header.liquid rendered (only one exists in the
 * DOM per page load).
 */
(function () {
  var CLEANUP_MS = 520; // >= longest keyframe duration (460ms), rounded up
  var cleanupTimer = null;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.header__heading-link');
    if (!link) return;

    var stamp = link.querySelector('.header__heading-logo-stamp');
    if (stamp) {
      // Force a restart even on rapid repeat clicks: drop the class, flush
      // layout, then re-add it so the keyframe animations replay from 0%.
      stamp.classList.remove('is-stamped');
      void stamp.offsetWidth;
      stamp.classList.add('is-stamped');
      // Drop the previous cleanup too, otherwise a rapid burst of clicks
      // leaves earlier timers pending and the first one to fire strips
      // .is-stamped mid-way through the newest animation.
      window.clearTimeout(cleanupTimer);
      cleanupTimer = window.setTimeout(function () {
        stamp.classList.remove('is-stamped');
      }, CLEANUP_MS);
    }

    // Already on the page the logo points to: skip the reload so the click
    // reads as pure feedback (the sweep) instead of a pointless page refresh.
    if (link.pathname === window.location.pathname && link.search === window.location.search) {
      event.preventDefault();
    }
  });
})();
